import { useState, useEffect, useCallback, useContext } from 'react';
import axios from 'axios';
import RefreshToken from '../../../partials/RefreshToken';
import { AuthContext } from '../../../../@jumbo/components/context/AuthContext';

const BASE = '/api/v1/private/dashboard/stats';

const fetchWithAuth = async (url, token) => {
  const { data } = await axios.get(`${process.env.REACT_APP_BASE_URL}${url}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data.data;
};

export default function useDashboardStats(autoRefreshInterval = 0) {
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    summary: null,
    transfers: null,
    agents: null,
    kyc: null,
    volume: null,
    users: null,
    pendingActions: null,
  });

  const fetchAll = useCallback(async () => {
    if (!glob_pay_admin_auth?.access_token) return;
    setLoading(true);
    setError(null);
    try {
      const token = await RefreshToken(glob_pay_admin_auth, logout, login);
      const [summary, transfers, agents, kyc, volume, users, pendingActions] = await Promise.all([
        fetchWithAuth(`${BASE}/summary`, token),
        fetchWithAuth(`${BASE}/transfers`, token),
        fetchWithAuth(`${BASE}/agents`, token),
        fetchWithAuth(`${BASE}/kyc`, token),
        fetchWithAuth(`${BASE}/volume`, token),
        fetchWithAuth(`${BASE}/users`, token),
        fetchWithAuth(`${BASE}/pending-actions`, token),
      ]);
      setStats({ summary, transfers, agents, kyc, volume, users, pendingActions });
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  }, [glob_pay_admin_auth, logout, login]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  useEffect(() => {
    if (autoRefreshInterval > 0) {
      const id = setInterval(fetchAll, autoRefreshInterval);
      return () => clearInterval(id);
    }
  }, [autoRefreshInterval, fetchAll]);

  return { stats, loading, error, refresh: fetchAll };
}
